module.exports = __webpack_public_path__ + "img/bell.4a396ed7.svg";